import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import cx from 'classnames';

import s from './LandingLegalPage.css';
import cs from '../commonStyle.css';
import { isRTL } from '../../helpers/formatLocale';

import LandingLegalSidebar from './LandingLegalSidebar';
import Footer from '../LandingFooter';

class LandingLegalPage extends React.Component {
  static propTypes = {
    activePage: PropTypes.oneOf(['terms', 'trust', 'help']).isRequired,
    pageTitleMessage: PropTypes.object.isRequired,
    children: PropTypes.node.isRequired,
    locale: PropTypes.string.isRequired,
    isAuthenticated: PropTypes.bool,
  };

  render() {
    const { activePage, pageTitleMessage, children, locale, isAuthenticated } = this.props;
    const isRtlLocale = isRTL(locale);

    return (
      <div
        className={cx('landingPage', s.legalRoot, isAuthenticated && s.legalRootWithSiteHeader)}
        dir={isRtlLocale ? 'rtl' : 'ltr'}
      >
        <div className={s.legalWrapper}>
          <main className={s.legalMain}>
            <h1 className={s.pageTitle}>
              <FormattedMessage {...pageTitleMessage} />
            </h1>
            {children}
          </main>
          <LandingLegalSidebar activePage={activePage} />
        </div>

        <Footer />
      </div>
    );
  }
}

const mapState = (state) => ({
  locale: state.intl.locale,
  isAuthenticated: state.runtime.isAuthenticated,
});

export default compose(
  withStyles(s, cs),
  connect(mapState),
)(LandingLegalPage);
